import { useTranslation } from 'react-i18next';
import useAlert from 'infrastructure/hooks/utils/use-alert';
import useUser from 'utils/useUser';
import TrashDeleteIcon from 'components/atoms/icons/trashIcon';
import { Button, Flex } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { useState, type FC } from 'react';
import { MAX_TEXT_LENGTH_FOR_EXPAND } from 'infrastructure/consts/tables';

import s from '../styles.module.scss';

interface Props {
  deleteNote?: any;
  value: any;
  record?: any;
  isDeletable?: boolean;
}

const NoteCommentsColumn: FC<Props> = ({
  deleteNote,
  value,
  record,
  isDeletable = true,
}) => {
  const { t } = useTranslation();
  const { Alert, showAlert } = useAlert();
  const { userType, isAdmin } = useUser();
  const [expanded, setExpanded] = useState(false);
  const shouldTruncate = value?.length > MAX_TEXT_LENGTH_FOR_EXPAND;

  const handleDelete = async () => {
    const message = `${t('labels.noteDeleteConfirm')} ${t(
      'labels.noteDeleteConfirmInteractiveTime',
    )}`;
    const alertAnswer = await showAlert({
      title: t('labels.commentDeleteTitle'),
      messageTitle: message,
      successBtnLabel: t('controls.yes'),
      rejectBtnLabel: t('controls.no'),
    });

    if (alertAnswer && record && deleteNote) {
      await deleteNote({
        guid: record?.guid,
        userType,
      });
    }
  };

  return (
    <div
      style={{
        wordBreak: 'break-word',
      }}
    >
      {isAdmin && isDeletable && (
        <div className={s['top-right-actions']}>
          <button
            className={s['delete-button']}
            onClick={handleDelete}
            aria-label="Delete comment"
          >
            <TrashDeleteIcon />
          </button>
        </div>
      )}
      {Alert}
      <div data-cy="clinic-notes-note" className={s.note}>
        {shouldTruncate && !expanded
          ? `${value.slice(0, MAX_TEXT_LENGTH_FOR_EXPAND)}...`
          : value}
      </div>
      {shouldTruncate && (
        <Button
          type="link"
          onClick={() => setExpanded(!expanded)}
          className={s['expand-button']}
        >
          <Flex gap={8} className={s['expand-button']}>
            {expanded ? (
              <>
                {t('labels.showLess', 'Show less')} <UpOutlined />
              </>
            ) : (
              <>
                {t('labels.showMore', 'Show more')} <DownOutlined />
              </>
            )}
          </Flex>
        </Button>
      )}
    </div>
  );
};

export default NoteCommentsColumn;
